/* eslint-disable no-unused-vars */
import React from "react";
import WorkSpace from "./WorkSpace";
import REACT_APP from "../../environment";
import Spinner from "react-spinner-material";
import axios from "axios";

const Library = () => {
    const [loading, setLoading] = React.useState(true);
    const [bgdDisable, setbgdDisable] = React.useState(null);

    const getData = async () => {
        await axios
            .get(`${REACT_APP.URL}/api/hrp/tts/adm/policy/bgd`, {
                headers: { Authorization: sessionStorage.getItem("token"), "client-id": REACT_APP.CLIENTID, "client-secret": REACT_APP.SECRET },
            })
            .then((res) => {
                setbgdDisable(res.data.data.disabled);
            })
            .catch((err) => {
                console.log(err);
            });
        setLoading(false)
    };

    React.useEffect(() => {
        getData();
    }, [])

    return (
        <div style={{ padding: "20px" }}>
            {loading ? (
                <div
                    style={{
                        marginTop: "100px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Spinner radius={150} color={"#1976d2"} stroke={16} visible={true} />
                </div>
            ) : typeof bgdDisable === "boolean" ? <WorkSpace bgdDisable={bgdDisable} setbgdDisable={setbgdDisable} />
                : <></>}
        </div>
    );
};

export default Library;
